"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorIcon = void 0;
var react_1 = __importDefault(require("react"));
var build_svg_icon_1 = require("./build-svg-icon");
exports.ErrorIcon = (0, build_svg_icon_1.buildSvgIcon)(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M11 7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V7Z" }),
    react_1.default.createElement("path", { d: "M13.25 16.75C13.25 17.4404 12.6904 18 12 18C11.3096 18 10.75 17.4404 10.75 16.75C10.75 16.0596 11.3096 15.5 12 15.5C12.6904 15.5 13.25 16.0596 13.25 16.75Z" })), 'ErrorIcon');
exports.default = exports.ErrorIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9pY29ucy9FcnJvci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsZ0RBQTBCO0FBQzFCLG1EQUFnRDtBQUVuQyxRQUFBLFNBQVMsR0FBRyxJQUFBLDZCQUFZLEVBQ25DO0lBQ0Usd0NBQU0sQ0FBQyxFQUFDLHlIQUF5SCxHQUFHO0lBQ3BJLHdDQUFNLENBQUMsRUFBQyw2SkFBNkosR0FBRyxDQUN2SyxFQUNILFdBQVcsQ0FDWixDQUFDO0FBRUYsa0JBQWUsaUJBQVMsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/Error.js
// module id = 3432
// module chunks = 25